<template>
    <div class="xc-home">
        <div class="xc-home-sidebar">
            <xc-sidebar
                :data="menuList"
                label-key='name'
                id-key='id'
                @select="selectMenu"
                :urlPrefix="adminPath"
            />
        </div>
        <div class="xc-home-container">
            <div class="xc-home-header">
                <div class="title">网站标题</div>
            </div>
            <div class="xc-home-content">
                <iframe
                    v-if="pageUrl"
                    :src="pageUrl"
                    frameborder="0"
                ></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import menuList  from '../data/menu';

export default {
    name: 'project',
    data() {
        return {
            pageUrl: null,
            menuList: [],
            adminPath: this.$config.adminPath,
        }
    },
    created() {
        this.menuList = menuList;

        this.pageUrl = this.menuList[0].url;
    },
    methods: {
        selectMenu(nav) {

            // 强制更新
            if (this.pageUrl && this.pageUrl == nav.url) {
                return document.querySelector('iframe').src = document.querySelector('iframe').src;
            }

            this.pageUrl = this.adminPath + nav.url;
        },
    }
}
</script>

<style scoped lang="scss">
</style>

